import { OperationReworkModel } from "./operation-rework.model";

export class WorkstationReworkModel {
    workstationId: string;
    workstationDesc: string;
    totalRework: number; // total times the rework flag is there in the hanger_routing
    operationWiseRework: OperationReworkModel[];

    constructor(workstationId: string,
        workstationDesc: string,
        totalRework: number,
        operationWiseRework: OperationReworkModel[]
        ) {
            this.workstationId = workstationId;
            this.workstationDesc = workstationDesc;
            this.totalRework = totalRework;
            this.operationWiseRework = operationWiseRework;
    }
}